<script setup>
import { onMounted,onUnmounted,reactive,ref, defineProps, watch } from 'vue';
import * as echarts from "echarts";
import {chartPieIntegerRate, chartPieRate} from "../../tool/number";

const props = defineProps({
    data: {
        type: Array,
        default: []
    },
    pieColors: {
        type: Array,
        default: [
            "rgba(152, 60, 248, 1)",
            "rgba(15, 60, 248, 1)",
            "rgba(81, 65, 244, 1)",
            "rgba(48, 128, 232, 1)",
            "rgba(49, 201, 232, 1)",
            "rgba(45, 232, 189, 1)",
            "rgba(49, 231, 73, 1)",
            "rgba(164, 232, 47, 1)",
            "rgba(232, 226, 47, 1)",
            "rgba(231, 183, 47, 1)",
            "rgba(232, 140, 48, 1)",
            "rgba(198, 125, 84, 1)",
            "rgba(38, 158, 161, 1)",
            "rgba(34, 72, 199, 1)",
            "rgba(255, 164, 164, 1)"
        ]
    }
})

const industryChartDOM = ref(null);
const industryValue = reactive({ value: 0, name: '' });
const industryList = ref([]);
let industryChartInstance;
function industryChart() { //XX城市群租户行业分布占比
    industryChartInstance = echarts.init(industryChartDOM.value);
    let option = {
        grid: {
            left: 0
        },
        series: [
            {
                type: 'pie',
                radius: ['50%', '70%'],
                data: props.data,
                color: props.pieColors,
                labelLine: {
                    show: false
                },
                label: {
                    show: false
                }
            }
        ]
    };
    industryChartInstance.setOption(option);

    industryChartInstance.on('mouseover', 'series', function (e) {
        industryValue.value = e.data.value;
        industryValue.name = e.data.name
    })

    industryChartInstance.on('mouseout', 'series', function (e) {
        industryValue.value = 0;
        industryValue.name = ''
    })
}

let total = ref(0)
function getIndustryList() {
    industryList.value = props.data.map((item, index) => {
        total.value =total.value +  Number(item.value)
        return {
            name: item.name,
            color: props.pieColors[index],
            data: item.value
        }
    })
}

function initIndustryList() {
    getIndustryList();
    industryChart();
}

function resizePie() {
    industryChartInstance && industryChartInstance.resize();
}

watch(props, () => {
    total.value = 0
    initIndustryList();
})

onMounted(() => {
    window.addEventListener('resize', resizePie);
})

onUnmounted(() => {
    window.removeEventListener('resize', resizePie);
})
</script>

<template>
    <div class="u-agg-chart-pie-content">
        <div class="u-agg-ci-chart-box">
            <div class="u-agg-ci-chart" ref="industryChartDOM"></div>
            <div class="u-agg-ci-info" v-show="industryValue.name !== ''">
                <p><b>{{chartPieRate(industryValue.value, total) }}</b></p>
                <span>{{ industryValue.name }}</span>
            </div>
        </div>
        <div class="u-agg-ci-legend">
            <div class="u-agg-cil" v-for="item in industryList" :key="item.name">
                <div class="u-agg-title">
                    <i :style="{ 'background': item.color }"></i>
                    <span>{{ item.name }}</span>
                </div>
<!--              ((item.data/total) * 100).toFixed(2) -->
                <span class="u-agg-cil-data">{{chartPieRate(item.data, total)}}</span>
            </div>
        </div>
    </div>
</template>

<style lang="less">
.u-agg-chart-pie-content {
    height: 100%;
    width: 100%;
    display: flex;
    overflow: hidden;

    .u-agg-ci-chart-box {
        width: 67%;
        height: 100%;
        flex-shrink: 0;
        position: relative;

        .u-agg-ci-chart {
            width: 100%;
            height: 100%;
        }

        .u-agg-ci-info {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;

            p {
                b {
                    font-size: 30px;
                    color: #333;
                }
            }

            span {
                color: #666;
                font-size: 12px;
            }
        }
    }

    .u-agg-ci-legend {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .u-agg-cil {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            &:first-child {
                margin-top: 0;
            }

            .u-agg-title {
                display: flex;
                align-items: center;
                color: #666;

                i {
                    width: 8px;
                    height: 8px;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }

            .u-agg-cil-data {
                color: #333;
            }
        }
    }
}
</style>